import ButtonController from "../../../components/containers/buttonController";
import DownloadButton from "../../../components/common/button/DownloadButton";
import Pagination from "../../../components/common/pagination/Pagination";
import useClearFilters from "../../../hooks/filter/useClearFilters";
import DynamicTable from "../../../components/tables/dynamicTable";
import { getFilteredReport } from "../../../utils/api/reportData";
import { getDynamicSelectData } from "../../../utils/api/data";
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from "../../../components/sidebar/Sidebar";
import NavBar from "../../../components/navbar/NavBar";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../makewellReport/makewellReport.css";
import { useSelector,  } from "react-redux";
import Cookies from "js-cookie";

const MakewellReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(250);
  const [rowsDisplayed, setRowsDisplayed] = useState(0);
  const [totalPages, setTotalPages] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredReportData, setFilteredReportData] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const reportFilters = useSelector((state) => state.report.reportFilter);
  const navigate = useNavigate();

  useClearFilters();

  //initial data fetch if no filters are selected
  useEffect(() => {
    const customer = Cookies.get("cp-cn");
    if (customer !== "makewell") {navigate(`/reportslanding`);}
    
    const hasActiveFilters = reportFilters.some(
      (filter) =>
        filter.field !== "" && filter.operator !== "" && filter.value !== ""
    );
    if (hasActiveFilters) {
      filterReport();
    } else { getMakewellData(); setTotalPages(100); }
  }, [reportFilters]);

  //get filtered data with selected filters
  const filterReport = async () => {
    setLoading(true);
    const filteredData = await getFilteredReport( "makewellreport", Cookies.get("cp-cn"), reportFilters );
    setFilteredReportData(filteredData);
    setDownloadData(filteredData);
    setTotalPages(Math.ceil(filteredData.length / pageSize));
    setCurrentPage(1);
    setLoading(false);
  };

  //update the rows displayed based on the current page and page size
  useEffect(() => {
    const customer = Cookies.get("cp-cn");
    if (filteredReportData.length > 0) {
      setReportData(
        filteredReportData.slice(rowsDisplayed, rowsDisplayed + pageSize)
      );
    } else if (customer === "makewell") {
      getMakewellData();
    }
  }, [filteredReportData, rowsDisplayed, pageSize]);

  //data call from sql with offset for pagination
  const getMakewellData = async () => {
    const responseSelect = await getDynamicSelectData({
      selectValues:
        '"Ordernumber" AS ORDER_NUMBER, "trackingnumber" AS TRACKING_NUMBER, "eventcategory" AS EVENT_CATEGORY, "eventdescription" AS EVENT_DESCRIPTION, "carrier" AS CARRIER, CONVERT(VARCHAR, "datesenttoshiphero", 101) AS DATE_RETRIEVED_ORDER_FILE, CONVERT(VARCHAR, "dateretrievedtrackingnumber", 101) AS DATE_RETRIEVED_TRACKING_NUMBER, "laststatussent" AS LAST_STATUS_SENT, "expecteddelivery" AS EXPECTED_DELIVERY, CONVERT(VARCHAR, "lastchecked", 101) AS LAST_STATUS_SENT_DATE',
      tableName: "saasproduction.dbo.makewelltracking",
      whereField: ["OrderNumber"],
      whereOperators: [">"],
      whereValue: ["0"],
      orderBy: "Ordernumber",
      offset: { rowsDisplayed: rowsDisplayed, pageSize: pageSize },
    });
    setLoading(false);
    setReportData(responseSelect);
    setDownloadData(responseSelect);
  };

  //handle page change
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setRowsDisplayed((newPage - 1) * pageSize);
  };

  return (
    <div className="serviceStatsPage">
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="makewellPageContent">
          <div className="laneviewTrendsTop">
            <div className="laneviewTrendsTitle">
              <h1>Makewell Report</h1>
            </div>
          </div>
          <div className="makewellMid">
            <div className="makewellreportSpace">
              <div className="report">
                {loading ? (
                  <CircularProgress style={{ margin: 'auto', display: 'block' }} />
                ) : (
                  <DynamicTable dataObject={{ data: reportData, size: "small" }} />
                )}
              </div>
              <div className="reportButtons">
                <div>
                  <DownloadButton data={downloadData} fileName={"makewellReport"}/>
                </div>
                <div className="paginationContainer">
                  <Pagination totalPages={totalPages} onPageChange={handlePageChange} boundaryCount={2}/>
                </div>
                <div>
                  <ButtonController reportName={'Makewell Report'} />
                </div>
              </div>
            </div>
          </div>
          <div className="laneviewTrendsBottom"></div>
        </div>
      </div>
    </div>
  );
};

export default MakewellReport;
